const CONTRADICTION_PERIOD_YEAR_LIMIT = 1;
const CONTRADICTION_DELIVERY_DAY_LIMIT = 360;

const useGetContradictionTranslationKeys = (periodYear: number, dateOfDelivery: Date) => {
  const contradictionPossibleByYear = new Date().getFullYear() - periodYear <= CONTRADICTION_PERIOD_YEAR_LIMIT;
  const contradictionPossibleByDelivery =
    (new Date().getTime() - dateOfDelivery.getTime()) / 86400000 <= CONTRADICTION_DELIVERY_DAY_LIMIT;

  let contractDictionByPeriodKey = 'list.period_year_contradiction_possible';
  if (!contradictionPossibleByYear) {
    contractDictionByPeriodKey = 'list.period_year_contradiction_not_possible';
  }

  let contractDictionByDeliveryKey = 'list.date_of_delivery_contradiction_possible';
  if (!contradictionPossibleByDelivery) {
    contractDictionByDeliveryKey = 'list.date_of_delivery_contradiction_not_possible';
  }

  return {
    contractDictionByPeriodKey,
    contractDictionByDeliveryKey,
  };
};

export default useGetContradictionTranslationKeys;
